<template>
  <hr />
</template>

<script>
export default {
  name: "SbHorizontalRule",
};
</script>
